export default {
  columns: {},
  columnsActivities: {},
  columnsLoading: false,
  binnacle: {}
};
